import Vue from 'vue'

export default {
  create: function (type) {
    let resource = Vue.axiosFactory.create({baseURL: 'app/projects/' + type})

    return {
      count() {
        return resource({method: 'get', url: '/count'})
      },
      findById(projectId) {
        return resource({method: 'get', url: projectId})
      },
      create(project) {
        return resource({method: 'post', data: project})
      },
      listSites(projectId) {
        return resource({method: 'get', url: projectId + '/list_sites'})
      },
      listSitesByDomain(domain) {
        return resource({method: 'get', url: '/list_sites_by_domain', params: {domain}})
      },
      listKeywords(projectId, options) {
        return resource({method: 'get', url: projectId + '/list_keywords', params: options})
      },
      // findByIdWithSites(projectId) {
      //   let projectPromise = this.findById(projectId)
      //   let sitesPromise = this.listSites(projectId)
      //
      //   return Promise.all([projectPromise, sitesPromise]).then(([project, sites]) => {
      //     project.sites = sites
      //     return project
      //   })
      // },
      update(project) {
        return resource({method: 'put', url: project._id, data: project})
      },
      listProjectsWithSitesDomain() {
        return getProjectsWithDomains(resource(({method: 'get'})), resource({
          method: 'get',
          url: '/domains_by_project'
        }))

        function getProjectsWithDomains(projectsPromise, domainsByProjectDataPromise) {
          return Promise.all([projectsPromise, domainsByProjectDataPromise])
            .then(([projectsData, domainsByProjectData]) => {
              let domainsByProjectMapper = {}
              let projects = projectsData.projects

              domainsByProjectData.domainsByProject.forEach(p => {
                domainsByProjectMapper[p._id] = p.domains
              })

              projects.filter(p => p.name !== '!_EMPTYLINKS').forEach((p) => {
                p.firstScanDate = ''
                p.domains = domainsByProjectMapper[p._id]
                p.totalSites = (p.domains || []).length
              })

              return projects
            })
        }
      },
      remove(projectsId) {
        return resource({method: 'delete', url: projectsId})
      },
      reuploadAndChangeToJekyll(projectId, siteId) {
        return resource({method: 'post', url: projectId + '/reupload_as_jekyll', data: {siteId}})
      },
      moveToEmptyAndDeleteLinks(projectId) {
        return resource({method: 'post', url: projectId + '/move_to_empty_delete_links'})
      },
      setSiteReupload(projectId, siteId) {
        return resource({method: 'post', url: 'setreupload', data: {siteId, projectId}})
      },
      setSiteReconfigure(domain) {
        return resource({method: 'post', url: 'setreconfigure', data: {domain}})
      },
      moveSite(siteId, srcProjectId, targetProjectId) {
        return resource({method: 'post', url: 'move_site', data: {siteId, srcProjectId, targetProjectId}})
      }
    }
  }
}
